import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class SatisfacaoService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    ObterSatisfacaoServicoPorPeriodo(parameters) {
        return this.http.get(`${SCAMP_API.accountApiV1}/satisfacao-service/${parameters.dataInicial}/${parameters.dataFinal}`, { headers: this.account.composeHeaders() });
    }
}
SatisfacaoService.ngInjectableDef = i0.defineInjectable({ factory: function SatisfacaoService_Factory() { return new SatisfacaoService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: SatisfacaoService, providedIn: "root" });
